import React from 'react';
import './Header.css';
import ButtonVimeo from '../../Icons/SocialMedia/ButtonVimeo';
import ButtonEmail from '../../Icons/SocialMedia/ButtonEmail';
import ButtonInstagram from '../../Icons/SocialMedia/ButtonInstagram';
import ButtonSoundcloud from '../../Icons/SocialMedia/ButtonSoundCloud'

const Header = (props) => (
  <nav className='nav'>
    <button className='site-title' onClick={props.onModalOpen} >
    Jozef Devillé
    </button>
    <ButtonVimeo/>
    <ButtonEmail/>
    <ButtonInstagram/>
    <ButtonSoundcloud/>
  </nav>
);

export default Header;
